/**
 * How many texts a message is billed and delivered as. A text is 160
 * characters of the GSM 7-bit alphabet, or 70 once any character outside it
 * (an emoji, Hebrew, curly quotes) forces UCS-2; a longer message is split
 * into parts that each give up a few characters to the header joining them.
 */
const GSM_BASIC = '@£$¥èéùìòÇ\nØø\rÅåΔ_ΦΓΛΩΠΨΣΘΞÆæßÉ !"#¤%&\'()*+,-./0123456789:;<=>?' +
    '¡ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÑÜ§¿abcdefghijklmnopqrstuvwxyzäöñüà';
/** Characters the GSM alphabet sends with an escape, so each counts twice. */
const GSM_EXTENDED = '^{}\\[~]|€\f';
const GSM_BASIC_SET = new Set(GSM_BASIC);
const GSM_EXTENDED_SET = new Set(GSM_EXTENDED);
export function smsSegments(text) {
    const chars = Array.from(text);
    const gsm = chars.every((c) => GSM_BASIC_SET.has(c) || GSM_EXTENDED_SET.has(c));
    // UCS-2 counts in 16-bit units, so a character outside the basic plane is two.
    const characters = gsm
        ? chars.reduce((n, c) => n + (GSM_EXTENDED_SET.has(c) ? 2 : 1), 0)
        : text.length;
    const single = gsm ? 160 : 70;
    const part = gsm ? 153 : 67;
    if (characters === 0) {
        return { encoding: gsm ? 'GSM' : 'UCS2', characters: 0, segments: 0, remaining: single };
    }
    const segments = characters <= single ? 1 : Math.ceil(characters / part);
    const capacity = segments === 1 ? single : segments * part;
    return {
        encoding: gsm ? 'GSM' : 'UCS2',
        characters,
        segments,
        remaining: capacity - characters,
    };
}
//# sourceMappingURL=sms.js.map